import React, { useState, useEffect } from 'react';
import "../Layout/Layout.css";
import "../Layout/cart.css";
import Navbar from './mudole/navbar';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCapsules, faCartShopping, faCheck, faChevronRight, faDisease, faMicroscope, faMinus, faPlus, faSyringe } from '@fortawesome/free-solid-svg-icons';
import Foot from './foot';

function Cart() {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  const isScreen = windowWidth > 768;
  const content = isScreen ? <Desktop /> : <Mobile />;

  return (
    <body>
      {content}
    </body>
  );
};

const Desktop = () => {
  const [id,setid] = useState('190064');
  const [mahd,setmahd] = useState('#82S9Q'); // mã hóa đơn
  const [TotalAmount,setTotalAmount] = useState(0); // tổng tiền
  const [DirectDiscount,setDirectDiscount] = useState(0); // Giảm giá trực tiếp
  const [voucher,setvoucher] = useState(0); // Giảm giá voucher
  const [Save,setSave] = useState(0); // Tiết kiệm được =  (Giảm giá trực tiếp +  Giảm giá voucher)
  const product = [
    {id:1,img:"11.jfif",name:"Panadol Extra (Hộp đỏ)",price:234000,discount:5},
    {id:2,img:"51.jfif",name:"Tiffy Dey (Vỉ màu xanh lá)",price:112500,discount:0},
    {id:3,img:"111.jfif",name:"vitamin EGaviscon (Dạng gói hỗn dịch)",price:240000,discount:0}
  ];
  const vouchers = [
    {img:"imges/5-2-vitamin-b.jpg",name:"Giảm 10% cho đơn hàng từ 0k tối đa giảm 100k",startdate:"9/10/2024",enddate:"10/10/2024",note:"",quantity:"100",used:"26",condition:"",value:"",type:"1"},
    {img:"imges/5-2-vitamin-b.jpg",name:"Giảm 200k cho đơn hàng trên 2tr",startdate:"10/10/2024",enddate:"15/10/2024",note:"",quantity:"100",used:"26",condition:"",value:"",type:"2"},
    {img:"imges/5-2-vitamin-b.jpg",name:"Giảm 300k cho đơn hàng trên 4tr",startdate:"10/10/2024",enddate:"15/10/2024",note:"",quantity:"100",used:"0",condition:"",value:"",type:"1"},
    {img:"imges/5-2-vitamin-b.jpg",name:"Giảm 200k cho đơn hàng trên 2tr",startdate:"11/10/2024",enddate:"15/10/2024",note:"",quantity:"100",used:"98",condition:"",value:"",type:"1"},
    {img:"imges/5-2-vitamin-b.jpg",name:"Giảm 200k cho đơn hàng trên 2tr",startdate:"11/10/2014",enddate:"15/10/2024",note:"",quantity:"100",used:"100",condition:"",value:"",type:"1"},
  ];
  const [selectAll, setSelectAll] = useState(false);  
  const handleSelectAll = () => {
    setSelectAll(!selectAll);
    setClickedButtons(selectAll ? [] : product.map(item => item.id));
    setTotalAmount(selectAll ? 0 : product.reduce((total, item) => total + item.price, 0));
    setSave(selectAll ? 0 : product.reduce((total, item) => total + ((item.price * item.discount) / 100), 0));
    setDirectDiscount(selectAll ? 0 : product.reduce((total, item) => total + ((item.price * item.discount) / 100), 0));
  };
  const [count, setCount] = useState(1);
  const handleIncrement = () => {
    setCount(count + 1);
  };
  const handleDecrement = () => {
    if (count > 1) {
      setCount(count - 1);
    }
  };
  const [today, settoday] = useState("9/10/2024") 
  const productCount = product.length;
  const [clickedButtons, setClickedButtons] = useState([]);
  const handleClickinput = (buttonValue) => {
  // Nếu giá trị chưa có trong mảng thì thêm vào
  if (!clickedButtons.includes(buttonValue)) {
    setClickedButtons([...clickedButtons, buttonValue]);
    const newTotalAmount = product.filter(item => item.id === buttonValue).map(item => item.price);
    setTotalAmount(Number(TotalAmount) + Number(newTotalAmount));
    const newSave = product.filter(item => item.id === buttonValue).map(item =>  (item.price * item.discount) / 100);
    setSave(Number(Save) + Number(newSave));
    const newDirectDiscount = product.filter(item => item.id === buttonValue).map(item =>  (item.price * item.discount) / 100);
    setDirectDiscount(Number(DirectDiscount) + Number(newDirectDiscount));
  } else {
    // Nếu giá trị đã có trong mảng thì xóa
    setClickedButtons(clickedButtons.filter(value => value !== buttonValue));
    const newTotalAmount = product.filter(item => item.id === buttonValue).map(item => item.price);
    setTotalAmount(Number(TotalAmount) - Number(newTotalAmount));
    const newSave = product.filter(item => item.id === buttonValue).map(item =>  (item.price * item.discount) / 100);
    setSave(Number(Save) - Number(newSave));
    const newDirectDiscount = product.filter(item => item.id === buttonValue).map(item =>  (item.price * item.discount) / 100);
    setDirectDiscount(Number(DirectDiscount) - Number(newDirectDiscount));
  }
  };
  const [showvoucher,setshowvoucher] = useState(true);
  const handleshowvoucher = () => {
    setshowvoucher(!showvoucher)
  };
  const [showsupport,setshowsupport] = useState(true);
  const handleshowsupport = () => {
    setshowsupport(!showsupport)
  };
  return (
    <body class='Desktop'>
        <Navbar />
        <div class='cart'>
            <div class='cart-left'>
                <div class='cart-left-1'>
                    <div class='head-hd' onClick={handleshowvoucher}>
                        <p>Sử dụng mã ưu đãi cho đơn hàng</p>
                        <div class='head-hd-icon'>
                          <FontAwesomeIcon icon={faChevronRight} style={{width:"50%"}}/>
                        </div>
                    </div>
                    <hr></hr>
                    <div class='body-hd'>
                      <div class='body-hd-left'>
                          <p>Tổng tiền</p>
                          <p>Giảm giá trực tiếp</p>
                          <p>Giảm giá voucher</p>
                          <p>Tiết kiệm được</p>
                      </div>
                      <div class='body-hd-right'>
                          <p>{TotalAmount.toLocaleString('vi-VN') + ' đ'}</p>
                          <p>{DirectDiscount.toLocaleString('vi-VN') +' đ'}</p>
                          <p>{voucher.toLocaleString('vi-VN') + ' đ'}</p>
                          <p>{Save.toLocaleString('vi-VN') + ' đ'}</p>
                      </div>
                    </div>
                    <hr></hr>
                    <div class='foot-hd'>
                        <div class='foot-hd-left'>
                            <h3>Thành tiền</h3>
                        </div>
                        <div class='foot-hd-right'>
                          {Save === 0?
                            <>
                              <p style={{color:"#fff"}}><s>{TotalAmount.toLocaleString('vi-VN') + ' đ'}</s></p>
                            </>
                            :
                            <>
                              <p><s>{TotalAmount.toLocaleString('vi-VN') + ' đ'}</s></p>
                            </>
                          }
                            <h3>{(TotalAmount - Save).toLocaleString('vi-VN') + ' đ'}</h3>
                        </div>
                    </div>
                    <button>Mua hàng</button>
                </div>
                <div class='cart-left-2'>
                  <p>
                    Bằng việc tiến hành đặt mua hàng, bạn đồng ý với
                    <a href='/'> Điều khoản dịch vụ</a> và <a href='/'>Chính sách xử lý dữ liệu cá nhân </a>
                    của Nhà thuốc Phú Sang
                  </p>
                </div>
            </div>
            <div class='cart-right'>
             <table>  
              <thead>
                <tr style={{height:"40px"}}>
                  <th>
                    <label class="container">
                      <input type="checkbox" checked={selectAll} onChange={handleSelectAll}></input>
                      <FontAwesomeIcon icon={faCartShopping}  class="checkmark"/>
                    </label>
                  </th>
                  <th>sản phẩm</th>
                  <th>({productCount})</th>
                  <th>Đơn Giá</th>
                  <th>Số Lượng</th>
                  <th style={{color:"black"}}>Số Tiền</th>
                  <th>Thao Tác</th>
                </tr>
              </thead> 
              <tbody>
                    {product.map(item =>(
                    <tr key={item.id}>
                      <th>
                        <label class="container">
                          <input type="checkbox" checked={clickedButtons.includes(item.id)}  onChange={() => handleClickinput(item.id)}></input>
                          <FontAwesomeIcon icon={faCartShopping}  class="checkmark"/>
                        </label>
                      </th>
                      <th><img src={`imges/${item.img}`}alt='1'></img></th>
                      <th>{item.name}</th>
                      <th>
                        {(item.discount === 0) ? 
                        item.price.toLocaleString('vi-VN') + " đ"
                        : 
                        <div>
                           <div>
                            <s>{item.price.toLocaleString('vi-VN') + " đ"}</s>
                            <span>{((item.price) - ((item.price * item.discount) / 100 )).toLocaleString('vi-VN') +" đ"}</span>
                          </div>
                          <div>
                            <span style={{color:"red",fontSize:"13px"}}>sản phẩm giảm giá {item.discount}%</span>
                          </div>
                        </div>
                        }
                      </th>
                      <th>
                        <div>
                          <button onClick={handleIncrement}><FontAwesomeIcon icon={faPlus} /></button>
                          <button onClick={handleDecrement}><FontAwesomeIcon icon={faMinus} /></button>
                          <p>{count}</p>
                        </div>
                      </th>
                      <th>
                      {(item.discount === 0) ? (item.price * count ).toLocaleString('vi-VN') + " đ" : (((item.price) - ((item.price * item.discount) / 100 ))* count).toLocaleString('vi-VN') +" đ" }
                      </th>
                      <th><button class="delete-product">Xóa</button></th>
                    </tr> 
                    ))} 
                 </tbody>    
                <tfoot>
                  <tr>
                    <th>
                      <label class="container">
                        <input type="checkbox" checked={selectAll} onChange={handleSelectAll}></input>
                        <FontAwesomeIcon icon={faCartShopping}  class="checkmark"/>
                      </label>
                    </th>
                    <th>sản phẩm ({productCount})</th>
                  </tr>
                </tfoot>
              </table>
            </div>
        </div>
        <div className='delete-form'>

        </div>
        <div class='voucher' style={{display:showvoucher ? "none":"flex"}}>
          <div class='voucher-from'   >
            <div class='voucher-from-1'>
              <h3>Sử dụng mã ưu đãi cho đơn hàng</h3>
              <p onClick={handleshowsupport}>Hỗ Trợ<span>?</span></p>
            </div>
            <div class='voucher-from-2'>
              <p>Mã Voucher</p>
              <input type='text'></input>
              <button>ÁP DỤNG</button>
            </div>
            <div class='voucher-from-3'>
              {vouchers.length === 0 ?
             (
              <div>
                <div className='voucher-img'>
                  <img src='/imges/voucher.png' alt=''></img>
                  <FontAwesomeIcon icon={faCapsules} className='voucher-icon-1'/>
                  <FontAwesomeIcon icon={faDisease} className='voucher-icon-2'/>
                  <FontAwesomeIcon icon={faMicroscope} className='voucher-icon-3' />
                  <FontAwesomeIcon icon={faSyringe} className='voucher-icon-4' />
                </div>
                <h3>Chưa có mã giảm giá nào :((</h3>
                <p>Nhập mã giảm giá có thể sử dụng vào thanh bên trên</p>
              </div>
              )
              :
              (
                vouchers.map((vouchers) => 
                  <div className='list-voucher'>
                    <img src={vouchers.img} alt=''></img>
                    <div className='infor-voucher'>
                       <p>{vouchers.name}</p>

                    </div>
                    <label class="container">
                      <input type="radio"name='voucher' ></input>
                      <FontAwesomeIcon icon={faCheck} class="checkmark"/>
                    </label>
                    {vouchers.startdate === today ? "":
                    <div className='list-voucher-1'></div>}
                  </div>
                )
              )
             
              }
            </div>
            <div class='voucher-from-4'>
              <button onClick={handleshowvoucher} >TRỞ LẠI</button>
              <button>ÁP DỤNG</button>
            </div>
            <div style={{display:showsupport ? "none":"block"}} className='support'>
              <h1>Hỗ Trợ</h1>
              <p>Cách Sử Dụng Voucher</p>
              <span>Để có thể áp dụng mã Shopee voucher, bạn hãy chọn nút "Lưu" để lấy voucher về mục ví voucher của bạn nhé.</span>
              <p>Cách Tìm Voucher</p>
              <span>
                Bạn có thể tìm thấy Shopee Voucher xuyên suốt trang shopee.vn và ứng dụng shopee. Mẹo riêng cho bạn nè, hãy bắt đầu với
                những trang chương trình khuyến mãi và trang chủ của shop nhé!
              </span>
            </div>
          </div>
        </div>
        <Foot/>
    </body>
  );
};
const Mobile = () => {
  return (
    <body>
       
    </body>
  );
};
export default Cart;
